import React from 'react';
import Rater from 'react-rater';
import 'react-rater/lib/react-rater.css';

interface RaterProps {
	total?: number;
	rating?: number;
	interactive?: boolean;
	onRate?: (event: { rating: number }) => void;
	className?: string;
	[key: string]: unknown;
}

const RaterWrapper: React.FC<RaterProps> = ({ total = 5, rating = 0, interactive = true, onRate, ...rest }) => {
	// Avoid relying on defaultProps by setting defaults in destructured props
	return <Rater total={total} rating={rating} interactive={interactive} onRate={onRate} {...rest} />;
};

export default RaterWrapper;
